import React, {
  useEffect,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import Spinner from "./Spinner";

import {
  getAccessToken,
  getRefreshToken,
} from "../../utils/authStorage";

// =====================================================
// IS LOGIN
// =====================================================

const IsLogin = ({
  children,
}) => {
  const [loading, setLoading] =
    useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const initializeAuth =
      () => {
        try {
          const accessToken =
            getAccessToken();

          const refreshToken =
            getRefreshToken();

          // ==========================================
          // NO TOKEN AT ALL
          // ==========================================

          if (
            !accessToken &&
            !refreshToken
          ) {
            navigate("/signin", {
              replace: true,
            });

            return;
          }

          // ==========================================
          // IMPORTANT
          //
          // Don't decode/check access token expiry.
          //
          // HotelApi handles 401 automatically.
          // ==========================================

          setLoading(false);
        } catch (error) {
          navigate("/signin", {
            replace: true,
          });
        }
      };

    initializeAuth();
  }, [navigate]);

  // ================================================
  // LOADING
  // ================================================

  if (loading) {
    return <Spinner />;
  }

  // ================================================
  // PRIVATE APPLICATION
  // ================================================

  return children;
};

export default IsLogin;